var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.content)?_c('div',{class:[`${_vm.$appPrefix}-rich-text`, `${_vm.$appPrefix}-rich-text--${_vm.theme}`],domProps:{"innerHTML":_vm._s(_vm.content)}}):_c('div',{class:[`${_vm.$appPrefix}-rich-text`, `${_vm.$appPrefix}-rich-text--${_vm.theme}`]},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }